<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Fully automate your app store publishing process using your existing CI/CD pipelines.'
    "
    [icon]="'@tui.refresh-cw'"
    [subtitle]="'Automation'"
    [title]="'Automate your deployment pipeline'"
  >
  </app-section-header>
  <div class="w-full text-base">
    <div
      class="flex justify-between rounded-t-[--tui-radius-l] bg-[#1E1E1E] p-4"
    >
      <div class="flex flex-row items-center gap-4">
        <div class="h-3 w-3 rounded-full bg-[#FF5F56]"></div>
        <div class="h-3 w-3 rounded-full bg-[#FFBD2E]"></div>
        <div class="h-3 w-3 rounded-full bg-[#27C93F]"></div>
      </div>
      <span class="font-bold text-white">.github/workflows/deploy.yml</span>
      <div></div>
    </div>
    <div
      class="h-[400px] overflow-x-auto overflow-y-auto rounded-b-[--tui-radius-l] bg-[#121212] p-4 md:p-6"
    >
      <code class="code" [innerHTML]="code | codeToHtml | async"></code>
    </div>
  </div>
</section>
